"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ReviewCycleAutomationStatusV2 () {
        return ReviewCycleAutomationStatusV2;
    },
    get ReviewCycleEmbeddedWorkflowModelV2 () {
        return ReviewCycleEmbeddedWorkflowModelV2;
    },
    get ReviewCycleJobStatusV2 () {
        return ReviewCycleJobStatusV2;
    },
    get ReviewCycleModelV2 () {
        return ReviewCycleModelV2;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _reviewtemplate = require("./review-template");
const ReviewCycleAutomationStatusV2 = _zod.z.enum([
    "disabled",
    "scheduled",
    "active",
    "ended"
]).nullable();
const ReviewCycleJobStatusV2 = _zod.z.enum([
    "idle",
    "building",
    "updating"
]);
const ReviewCycleEmbeddedWorkflowModelV2 = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    forms: _zod.z.array(_reviewtemplate.ReviewTemplateFormModel)
});
const ReviewCycleModelV2 = _zod.z.object({
    // Built-ins
    _id: _zod.z.instanceof(_bson.ObjectId),
    company: _zod.z.instanceof(_bson.ObjectId),
    creator: _zod.z.instanceof(_bson.ObjectId).nullish(),
    timezone: _zod.z.string().optional(),
    // Template snapshot
    workflow: ReviewCycleEmbeddedWorkflowModelV2,
    // Configuration
    name: _zod.z.string(),
    start_date: _zod.z.date(),
    admins_only: _zod.z.boolean().optional(),
    department: _zod.z.instanceof(_bson.ObjectId).nullable().optional(),
    // Relationships
    subjects: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
    reviews: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    user_selection: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    easy_add_configs: _zod.z.array(_zod.z.instanceof(_bson.ObjectId).nullable()).optional(),
    completed_reviews: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    // Automation
    automated: _zod.z.boolean().optional().default(false),
    automation_status: ReviewCycleAutomationStatusV2.optional(),
    // Status
    completed: _zod.z.boolean().optional(),
    complete_date: _zod.z.date().nullable().optional(),
    closed: _zod.z.boolean().optional(),
    deleted: _zod.z.boolean().optional(),
    job_status: ReviewCycleJobStatusV2.optional(),
    // Timestamps
    created_at: _zod.z.date().optional(),
    updated_at: _zod.z.date().optional(),
    updated_by: _zod.z.instanceof(_bson.ObjectId).optional(),
    deleted_at: _zod.z.date().optional(),
    deleted_by: _zod.z.instanceof(_bson.ObjectId).optional()
});
